var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLargeBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292893 7.29875C-0.0976311 7.68928 -0.0976311 8.32244 0.292893 8.71297L6.65685 15.0769C7.04738 15.4675 7.68054 15.4675 8.07107 15.0769C8.46159 14.6864 8.46159 14.0532 8.07107 13.6627L2.41421 8.00586L8.07107 2.34901C8.46159 1.95848 8.46159 1.32532 8.07107 0.934792C7.68054 0.544267 7.04738 0.544267 6.65685 0.934792L0.292893 7.29875ZM21 9.00586C21.5523 9.00586 22 8.55814 22 8.00586C22 7.45357 21.5523 7.00586 21 7.00586V9.00586ZM1 9.00586L21 9.00586V7.00586L1 7.00586L1 9.00586Z",
    fill: "#A8A7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeBackArrow);
export default __webpack_public_path__ + "static/media/large-back-arrow.d48e057b619260e6c0d3d28167cc42c6.svg";
export { ForwardRef as ReactComponent };